import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=dd3a7d3a&scoped=true&"
import script from "./UserSettings.vue?vue&type=script&lang=js&"
export * from "./UserSettings.vue?vue&type=script&lang=js&"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=dd3a7d3a&lang=scss&scoped=true&"
import style1 from "./UserSettings.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3a7d3a",
  null
  
)

export default component.exports